import { KeyboardEvent, MouseEvent, useCallback, useEffect, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"

import { AgGridReact } from "ag-grid-react"
import { MST1110_R01Content } from "./Content_MST1110_R01"
import { defaultMST1110_R01Dto, MST1110_R01Dto } from "./Dto_MST1110_R01"
import { MST1110_R01SearchSection } from "./SearchSection_MST1110_R01"
import { useMST1110_R01Store } from "./Store_MST1110_R01"
import { MST1110_R01Table } from "./Table_MST1110_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_MST1110_R01 = () => {
	

	const { 
		MST1110_R01List,
		insertMST1110_R01List,
		removeMST1110_R01List,
		addDeletedMST1110_R01List,
		allCount,
		initData 
	} = useMST1110_R01Store();
	const { setMessage } = useUiuxStore();

	

	const gridRef = useRef<AgGridReact<MST1110_R01Dto>>(null);

	// UserContent에서 필요한 핸들러 함수들을 가져옴
	const {
		clickable, setClickable,
		handleExcelClick,
		handlePrintClick,
		defaultMST1110_R01Row,
		fetchData,
		initContainerData,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
		buttonDisabled,
	} = MST1110_R01Content({
		gridRef,
		setMessage,
		
	});

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onPrintClick={handlePrintClick}
			onInitClick={initContainerData}
		/>
		
		<MST1110_R01SearchSection 
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<MST1110_R01Table 
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultMST1110_R01Row={defaultMST1110_R01Row()}
					handleInsertClick={handleInsertClick}
				/>
			</div>
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}